import React, { useState } from 'react';
import UserGroups from './userGroups';
import GroupDetails from './groupDetails';
import UserDetails from './userDetails';
import toastService from '../../services/toastService';

import { put, post } from '../../utils/apiUtils';

const GroupUserNavComponent = () => {
  const [activePage, setActivePage] = useState('groupListing');
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const showValidationErrors = (error) => {
    if (error.response && error.response.data && error.response.data.detail) {
      const errors = error.response.data.detail;
      errors.forEach(validationError => {
        const fieldName = validationError.loc[validationError.loc.length - 1];
        const message = validationError.msg;
        toastService.error(`${fieldName}: ${message}`);
      });
    } else {
      toastService.error('An error occurred while saving the user');
    }
  };

  const handleSelectGroup = (group) => {
    setSelectedGroup(group);
    setActivePage('groupDetails');
  };

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setActivePage('userDetails');
  };

  const handleSaveGroup = async (groupDetails) => {
    if (groupDetails && groupDetails.id) {
      try {
        const updateResponse = await put(`/api/v1/persistence/user_group`, groupDetails, {
          withCredentials: true,
        });
        setSelectedGroup(updateResponse);
      } catch (error) {
        console.error('Error updating group:', error);
      }
    } else {
      try {
        const createResponse = await post(`/api/v1/persistence/user_group`, groupDetails, {
          withCredentials: true,
        });
        setSelectedGroup(createResponse);
      } catch (error) {
        console.error('Error updating group:', error);
      }
    }

  };
  const handleSaveUser = async (userDetails) => {
    console.log('Save User:', userDetails);
    if (userDetails && userDetails.id) {
      try {
        const updateResponse = await put(`/api/v1/persistence/users`, userDetails, {
          withCredentials: true,
        });
        setSelectedUser(updateResponse);
        setActivePage('groupDetails');
        toastService.success('User updated successfully');
      } catch (error) {
        console.error('Error updating user:', error);
        showValidationErrors(error);
      }
    } else {
      try {
        userDetails.username = userDetails.email;
        const createResponse = await post(`/api/v1/persistence/users`, userDetails, {
          withCredentials: true,
        });
        setSelectedUser(createResponse);
        try {
          let payload = {
            group: selectedGroup.name,
            entity_id: createResponse.username,
            company_cd: createResponse.company_cd,
            entity_type: 'user'
          }
          const linkageResponse = await post(`/api/v1/persistence/user_group_mapping`, payload, {
            withCredentials: true,
          });
          setActivePage('groupDetails');
          toastService.success('User created and added to group successfully');

        } catch (error) {
          console.error('Error updating group Linkage:', error);
          toastService.error('User created but failed to add to group');
        }
      } catch (error) {
        console.error('Error creating user:', error);
        showValidationErrors(error);
      }
    }
  };

  return (
    <div>
      {activePage === 'groupListing' && <UserGroups onSelectGroup={handleSelectGroup} />}
      {activePage === 'groupDetails' && (
        <GroupDetails
          group={selectedGroup}
          onSelectUser={handleSelectUser}
          onSaveGroup={handleSaveGroup}
        />
      )}
      {activePage === 'userDetails' && (
        <UserDetails user={selectedUser} onSaveUser={handleSaveUser} selectedGroup={selectedGroup?.name} />
      )}
    </div>
  );
};

export default GroupUserNavComponent;